import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("[ZunoApp] Erro inesperado capturado", {
      name: error?.name || "Error",
      message: error?.message || "Erro desconhecido",
    });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" style={{ minHeight:"100dvh", padding:24, display:"grid", placeItems:"center", background:"#050816", color:"#f8fbff", fontFamily:"system-ui, sans-serif" }}>
        <section style={{ width:"min(100%, 480px)", padding:28, borderRadius:24, background:"#0c1430", border:"1px solid #24345d", textAlign:"center" }}>
          <h1 style={{ margin:"0 0 12px", fontSize:24 }}>Não foi possível abrir esta tela</h1>
          <p style={{ margin:"0 0 22px", color:"#b7c2dc", lineHeight:1.55 }}>Seus dados continuam protegidos. Verifique a conexão e tente novamente.</p>
          <button type="button" onClick={() => window.location.reload()} style={{ minHeight:48, padding:"12px 20px", border:0, borderRadius:14, background:"linear-gradient(135deg,#06b6d4,#7c3aed)", color:"white", fontWeight:800, cursor:"pointer" }}>
            Tentar novamente
          </button>
        </section>
      </main>
    );
  }
}
